module.exports = __webpack_public_path__ + "img/hq.093b8c3c.png";